export type TbmArtifactType = "tbm_scenario" | "tbm_record";

const decodeXmlText = (value: string) => value
  .replace(/&lt;/g, "<")
  .replace(/&gt;/g, ">")
  .replace(/&quot;/g, '"')
  .replace(/&#39;|&apos;/g, "'")
  .replace(/&amp;/g, "&")
  .replace(/\s+/g, " ")
  .trim();

const xmlText = (source: string, tag: string) => {
  const value = source.match(new RegExp(`<${tag}\\b[^>]*>([\\s\\S]*?)</${tag}>`, "i"))?.[1] ?? "";
  return decodeXmlText(value.replace(/<[^>]+>/g, " "));
};

export const deriveTbmArtifactTitle = (
  type: TbmArtifactType,
  xmlContent: string,
): string => {
  const suffix = type === "tbm_scenario" ? "TBM 시나리오" : "TBM 기록지";
  const firstHazardBlock = type === "tbm_scenario"
    ? xmlContent.match(/<topic\b[^>]*>([\s\S]*?)<\/topic>/i)?.[1] ?? ""
    : xmlContent.match(/<hazard_entry\b[^>]*>([\s\S]*?)<\/hazard_entry>/i)?.[1] ?? "";
  const rawBase = xmlText(xmlContent, "work_name") || xmlText(firstHazardBlock, "hazard");
  const base = rawBase.slice(0, 80).trim();
  return base ? `${base} ${suffix}` : suffix;
};
